var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ivu-icon ivu-icon-ios-loading demo-spin-icon-load"})
}
var staticRenderFns = []

export { render, staticRenderFns }